/**
 * Account Service
 *
 * Frontend service for account management (deletion)
 */

import { getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { getEmulatorHost, isUsingEmulators } from './emulator';

export async function deleteAccount(): Promise<void> {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error('Must be authenticated');
  }

  const idToken = await user.getIdToken(isUsingEmulators());

  const functions = getFunctions();
  const projectId =
    functions.app.options.projectId ||
    process.env.REACT_APP_FIREBASE_PROJECT_ID ||
    'postmortem-pheonix';
  const region = functions.region || 'us-central1';
  const baseUrl = isUsingEmulators()
    ? `http://${getEmulatorHost()}:${process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || '5001'}/${projectId}/${region}`
    : functions.customDomain || `https://${region}-${projectId}.cloudfunctions.net`;

  const controller = new AbortController();
  const timeoutMs = parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10);
  const timeoutId = setTimeout(() => controller.abort(), Number.isFinite(timeoutMs) ? timeoutMs : 30000);

  try {
    const response = await fetch(`${baseUrl}/deleteUserAccount`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error: any) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      throw new Error('Request timeout - delete account service not responding');
    }
    throw error;
  }
}
